import { LayoutPublic } from '@/layouts'

export const routePublic = [
  {
    path: '*',
    redirect: { name: 'home' },
  },
  {
    path: '/',
    name: 'home',
    component: LayoutPublic,
    redirect: { name: 'publicSearchNew', params: { type: 1 } },
    meta: {
      title: 'Pagrindinis',
      open: true,
    },
    children: [
      {
        path: `${process.env.VUE_APP_PUBLIC_PATH}`,
        name: 'publicSearchNew',
        component: () =>
          import(/* webpackChunkName: "PublicSearchNew" */ '@/views/publicSearch/PublicSearchNew.vue'),
        meta: {
          title: 'Paieška',
        },
      },
    ],
  },
]